import React from 'react'
import Modal from 'particles/Modal'

interface InfoModalProps {
    title: string
    subtext?: string
    buttonText: string
    onConfirm: React.MouseEventHandler<HTMLButtonElement>
    onClose: React.MouseEventHandler<HTMLButtonElement>
}

const InfoModal: React.FC<InfoModalProps> = ({ children, title, subtext, buttonText, onConfirm, onClose }) => {
    return (
        <Modal
            title={title}
            subtext={subtext}
            size="m"
            icon="info"
            primaryButtonProps={{ label: buttonText }}
            hasSecondaryButton={false}
            onConfirm={onConfirm}
            onClose={onClose}
        >
            {children}
        </Modal>
    )
}

export default InfoModal
